import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgSearchDimension = {
  height: 20,
  width: 20,
  viewBox: '0 0 20 20',
};
export const SvgSearch = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M8.333 3.333a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-6.666 5A6.667 6.667 0 1 1 13.6 12.421l4.49 4.49a.833.833 0 1 1-1.18 1.178l-4.489-4.49A6.667 6.667 0 0 1 1.666 8.333"
    />
  </svg>
));
